import React from 'react';
import styles from './ItemDetailWeaponN.scss';
import classNames from 'classnames/bind';

import {NumericFormat} from 'react-number-format';

import Adsense300250 from 'components/adsense/Adsense300250';

import { bodyUpList, powerUpList } from 'util/damageCalc';


// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faX
// } from '@fortawesome/free-solid-svg-icons';

const cx = classNames.bind(styles);

const ItemDetailWeapon = ({currSelWeapon, /*popupClose, */ctrlWeaponUp, setBodyup, setPowerup}) => {
  const bodyBtns = bodyUpList.map((ele, cnt) => {
    const {name} = ele;
  
    return (
      <React.Fragment key={cnt}>
        <input type='radio' id={`bodyUp${cnt}`} name='bodyUp'
        alt={name} value={name}/>
        <label className={cx(`up${cnt}`)} htmlFor={`bodyUp${cnt}`} onClick={() => setBodyup(cnt)}>{name}</label>
      </React.Fragment>
    )
  });
  const powerBtns = powerUpList.map((ele, cnt) => {
    const {name} = ele;
  
    return (
      <React.Fragment key={cnt}>
        <input type='radio' id={`powerUp${cnt}`} 
          name='powerUp' alt={name} value={name}
        />
        <label htmlFor={`powerUp${cnt}`} onClick={() => setPowerup(cnt)}>{name}</label>
      </React.Fragment>
    )
  });
  
  const {currItem, currItemPoweredBy, currItemOption} = currSelWeapon;
  const {bodyUp, powerUp, optionView} = currItemOption;
  const {ITEM_NM, IMG_SRC, DMG, CRI, ACCURACY_RATE, POINT_RATE, ITEM_DTL_DV, SPEED, TIER, SIZE, WEIGHT, CLYN, STYPE1} = currItem;
  const titleName = ITEM_NM === undefined ? '' : (CLYN === 'Y' ? powerUpList[powerUp].titleClName + ' ' + ITEM_NM.substr(4) : 
          powerUpList[powerUp].titleName + ' ' + ITEM_NM)
  return (
    <div className={cx('item-card')}>
      
      <h2>{titleName}</h2>
      <div className={cx('item-img')}>
        <img src={IMG_SRC} alt={titleName+' 이미지'} />
      </div>
    
      <div className={cx('item-btn-group')}>
        <button className={cx('item-btn')} onClick={ctrlWeaponUp} value='몸체'>몸체선택</button>
        <button className={cx('item-btn')} onClick={ctrlWeaponUp} value='강화'>강화선택</button>

        <div className={cx('combo-box')} style={optionView === '' ? {display:'none'} : (optionView === '강화' ? {left:'80px',display:'grid'} : {display:'grid'})}>
          {optionView === '몸체' ? bodyBtns : powerBtns}
        </div>
      </div>
      <div className={cx('adsense-300250')}><Adsense300250/></div>
      <div className={cx('item-info')}>
        <span style={{color:'#00ffff'}}>종류: 오른손도구</span>
        <span style={{color:'#ff5252'}}>
        <NumericFormat 
            value={currItemPoweredBy.length === 0 ? DMG : currItemPoweredBy[bodyUp][powerUp]} displayType={'text'} 
            thousandSeparator={true} 
            prefix={'파괴력: '}
          />
        </span>
        <span style={{color:'orange'}}>치명타: {CRI !== undefined ? String(Math.floor(CRI*1.5)) : '0'}</span>
        <span style={{color:'#ffaa00'}}>명중률: {ACCURACY_RATE !== undefined ? String(Math.floor(ACCURACY_RATE*100*1.5) > 100 ? 100 : Math.floor(ACCURACY_RATE*100*1.5)) : '0'}%</span>
        <span style={{color:'#ffaa00'}}>탄착률: {POINT_RATE !== undefined ? String(Math.floor(POINT_RATE*100*1.5) > 100 ? 100 : Math.floor(POINT_RATE*100*1.5)) : '0'}%</span>
        <span>분류: {ITEM_DTL_DV}</span>
        <span>속도: {SPEED}발/1분</span>
        <span>등급: {TIER}</span>
        <span>크기: {SIZE}</span>
        <span>무게: {WEIGHT}</span>
        <span>창고보관 보유갯수: 1개</span>
        <span className={cx('item-upgrade')}>
            <span className={cx(`up${bodyUpList[bodyUp].value}`)}>{bodyUpList[bodyUp].name}튜닝 몸체</span>
            <span className={cx('up3')}>전문튜닝 {STYPE1 === '01' ? '총열' : '칼날'}</span>
            <span className={cx('up3')}>전문튜닝 {STYPE1 === '01' ? '조준경' : '버팀쇠'}</span>
            <span className={cx('up3')}>전문튜닝 손잡이</span>
          </span>
      </div>
      
    </div>
  );
}

export default ItemDetailWeapon;